"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_CONFIRMATION_REQUIRED_PAID_PERCENTAGE = exports.ORDER_CONFIRMATION_TOTAL_CONSTRAINT = exports.MAX_CUSTOMER_NOTE_LENGTH = exports.DEFAULT_DESTINATION_RADIUS = void 0;
// Constants from legacy/models
exports.DEFAULT_DESTINATION_RADIUS = 15;
exports.MAX_CUSTOMER_NOTE_LENGTH = 1024;
exports.ORDER_CONFIRMATION_TOTAL_CONSTRAINT = 200;
exports.ORDER_CONFIRMATION_REQUIRED_PAID_PERCENTAGE = 20;
//# sourceMappingURL=models.js.map